var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance"},[_c('h1',[_vm._v("現在メンテナンス中です")]),_c('p',[_vm._v("We're currently down for maintenance. Please check back later.")])])
}]

export { render, staticRenderFns }